import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 按钮组件
 * 提供多种样式变体和状态
 */
export const Button = ({ children, variant = 'primary', size = 'medium', fullWidth = false, loading = false, disabled = false, startIcon, endIcon, className = '', minWidth, onClick, type = 'button', tooltip, showTooltip, hideTooltip, ...props }) => {
    // 基础样式类
    const baseClasses = 'font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
    // 尺寸样式映射
    const sizeClasses = {
        small: 'px-3 py-1.5 text-sm',
        medium: 'px-5 py-2.5 text-base',
        large: 'px-6 py-3 text-lg',
    };
    // 变体样式映射
    const variantClasses = {
        primary: 'bg-static-eggshell text-interactive-emerald-flash hover:bg-interactive-emerald-flash hover:text-white focus:ring-interactive-emerald-flash',
        secondary: 'bg-static-eggshell text-gray-600 hover:bg-static-cream-yellow focus:ring-static-cream-yellow',
        outline: 'bg-transparent border-2 border-static-sea-blue text-static-sea-blue hover:bg-static-beach-orange hover:text-white hover:border-transparent focus:ring-static-beach-orange',
        text: 'bg-transparent text-static-beach-orange hover:text-interactive-emerald-flash focus:ring-interactive-emerald-flash',
        danger: 'bg-static-eggshell text-interactive-coral-red hover:bg-interactive-coral-red hover:text-white focus:ring-interactive-coral-red',
    };
    // 组合所有样式类
    const buttonClasses = [
        baseClasses,
        sizeClasses[size],
        variantClasses[variant],
        disabled || loading ? 'opacity-60 cursor-not-allowed' : '',
        fullWidth ? 'w-full' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    // 加载指示器
    const loadingIndicator = loading && (_jsxs("svg", { className: "animate-spin -ml-1 mr-2 h-4 w-4 text-current", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })] }));
    // 处理点击事件
    const handleClick = (event) => {
        if (!disabled && !loading && onClick) {
            onClick(event);
        }
    };
    const handleMouseEnter = (e) => {
        if (tooltip && showTooltip) {
            showTooltip(tooltip, e.currentTarget);
        }
    };
    const handleMouseLeave = () => {
        if (hideTooltip) {
            hideTooltip();
        }
    };
    return (_jsx("button", { type: type, className: buttonClasses, disabled: disabled || loading, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, style: {
            minWidth: minWidth || '60px',
            ...props.style,
        }, ...props, children: _jsxs("div", { className: "flex items-center justify-center flex-wrap", children: [loadingIndicator, startIcon && _jsx("span", { className: "mr-2", children: startIcon }), children, endIcon && _jsx("span", { className: "ml-2", children: endIcon })] }) }));
};
// 默认导出，保持兼容性
export default Button;
//# sourceMappingURL=Button.js.map